import { observer } from 'mobx-react-lite';
import {
  Button,
  CheckboxField,
  PasswordField,
  RadioField,
  SavingIndicator,
  TextField,
  WidgetFooter,
} from '../../../../components';
import {
  getCdnProvidersInfo,
  getStorageProvidersInfo,
} from '../../../account/store/services/types';
import User from '../../store/User';

// PulseCDN and PulseCloud don't require a CDN setup
const HIDDEN_STORAGES = new Set(['bunnycdn.com', 'pulsecdn.net']);

const STORAGE_PROVIDERS = getStorageProvidersInfo().filter(
  ({ value }) => !HIDDEN_STORAGES.has(value),
);
const CDN_PROVIDERS = getCdnProvidersInfo();

export default observer(function CdnWidget({ user }: { user: User }) {
  const { configurations } = user;
  const { cdn } = configurations;

  return (
    <>
      <CheckboxField
        errorText={cdn.errors.enabled}
        helperText="Not needed for PulseCDN and PulseCloud, they are CDN-hosted already."
        label="Enabled"
        name="enabled"
        onBlur={cdn.handleBlur}
        onChange={cdn.handleChange}
        value={cdn.enabled}
      />
      {cdn.enabled && (
        <>
          {/* There is only one CDN service for now */}
          <RadioField
            errorText={cdn.errors.cdnProvider}
            label="CDN Service"
            name="cdnProvider"
            onBlur={cdn.handleBlur}
            onChange={cdn.handleChange}
            options={CDN_PROVIDERS}
            sx={{ display: 'none' }}
            value={cdn.cdnProvider}
          />
          <RadioField
            errorText={cdn.errors.s3Provider}
            label="Storage"
            name="s3Provider"
            onBlur={cdn.handleBlur}
            onChange={cdn.handleChange}
            options={STORAGE_PROVIDERS}
            value={cdn.s3Provider}
          />
          <TextField
            errorText={cdn.errors.bucket}
            label="Bucket"
            name="bucket"
            onBlur={cdn.handleBlur}
            onChange={cdn.handleChange}
            required
            value={cdn.bucket}
          />
          <TextField
            errorText={cdn.errors.cname}
            label="CNAME"
            name="cname"
            onBlur={cdn.handleBlur}
            onChange={cdn.handleChange}
            required
            value={cdn.cname}
          />
          <PasswordField
            errorText={cdn.errors.passphrase}
            label="Passphrase"
            name="passphrase"
            onBlur={cdn.handleBlur}
            onChange={cdn.handleChange}
            required
            value={cdn.passphrase}
          />
        </>
      )}
      <WidgetFooter>
        <Button
          disabled={cdn.hasErrors}
          disabledTooltip={cdn.allErrorsAsStrings}
          icon="save"
          onClick={() => cdn.save()}
          size="small"
          type="primary"
        >
          Save
        </Button>

        <SavingIndicator indicator={cdn.indicator} sx={{ ml: 2 }} />
      </WidgetFooter>
    </>
  );
});
